export default __webpack_public_path__ + "static/5-b61ffdd1314a202ba511aafe6eb38198.mp4";